import "./AboutPage.css";
import {
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";
import profile from "../assets/aboutme.jpg"; // update with your image path

function AboutPage() {
  return (
    <div className="about-container">
        <h1 className="about-title">Meet Raisa Islam Aishy</h1>
        <div className="about-grid">
            <img src={profile} alt="Raisa" className="about-image" />

            <div className="about-text">
                <p>
                    Hi, I’m Raisa — a 24-year-old computer engineering graduate, born and raised in the colorful, chaotic, and deeply beloved city of Dhaka, Bangladesh. 
                    These days, I call Toronto home, where I’ve swapped the rickshaw bells for streetcar chimes, but carry with me the warmth of my roots wherever I go. 
                    This blog is a reflection of that journey — one where my love for food and my passion for software development come together in one place.
                    <br /><br />
                    My story in the kitchen began before I even knew how to tie my shoelaces. I was three years old, standing on tiptoes beside my mother as she rolled 
                    out rotis for dinner. She’d give me my own little ball of dough, and I’d try to mimic her graceful movements, pressing and stretching it with all 
                    the focus in the world. My rotis were always lopsided, usually too thick, but she’d still cook them with a smile and place them proudly on the stack. 
                    That early sense of wonder and belonging in the kitchen never left me.
                    <br /><br />
                    One of my favorite times to cook was always during Ramadan. Iftar at our home in Dhaka wasn’t just a meal — it was an event. My mother and I would 
                    spend the afternoon preparing all the classics: crispy beguni, spicy chola boot, golden piyajus, sweet and syrupy jilapi, and pitchers of chilled
                    rooh afza, ready to be poured the moment the call to prayer rang out. I loved the flurry of movement, the fragrant spices, and the sacred pause that 
                    came with breaking our fast together. We always made sure to prepare extra plates to share — offering warm meals to those near the mosque who needed 
                    them when we set out for taraweeh prayers. That act of sharing, of feeding others with love, has always stayed with me.
                    <br /><br />
                    In 2020, I co-founded <a href="https://www.facebook.com/@NianrasPalate/" className="inline-link" target="_blank" rel="noreferrer">Nianra's Palate</a>, an online bespoke 
                    bakery with my cousin. It was born out of a shared dream and a tiny home kitchen — one order at a time. We spent months testing recipes, mastering sugar flowers,
                    writing handwritten notes to our customers, and building something that felt personal and proud. When I returned to Toronto to finish my degree at the 
                    University of Toronto, I had to let go of the business, but not of the joy it gave me.
                    <br /><br />
                    Now, with my degree in hand, I’m bringing my two worlds together — food and technology — by building this blog as a full-stack project. Every recipe 
                    I share here has a story. Some are rooted in memory, others in experimentation, but all are made with intention. You’ll find lots of Bengali and 
                    Indian dishes here, because they are my comfort food, my connection to home. But you’ll also find new flavors I’ve come to love and meals I’ve 
                    shared with friends around the world.
                    <br /><br />
                    Cooking, for me, is a way of remembering, a way of giving, and a way of creating joy. Thank you for being here — for reading, for following along, 
                    and for sharing in this journey with me. It means more than you know.
                </p>
            </div>
        </div>

        <div className="about-links">
            <a href="https://www.instagram.com/whatsriacookin" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://www.tiktok.com/@whatsriacookin" target="_blank" rel="noreferrer"><FaTiktok /></a>
            <a href="https://www.youtube.com/@whatsriacookin" target="_blank" rel="noreferrer"><FaYoutube /></a>
            <a href="https://www.linkedin.com/in/raisa-islam-aishy" target="_blank" rel="noreferrer"><FaLinkedin /></a>
            <a href="https://github.com/ria147" target="_blank" rel="noreferrer"><FaGithub /></a>
        </div>
    </div>
  );
}

export default AboutPage;